import React, { createContext } from "react";

const AccountSectionContext = createContext<any>(undefined);

export default AccountSectionContext;